import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { ApiProvider } from './providers/apiProvider';
import { AuthProvider } from './providers/authProvider';
import { QueryProvider } from './providers/queryProvider';
import { UserProvider } from './providers/userProvider';
import { ImpersonationProvider } from './providers/impersonationProvider';
import { router } from './router';
import { Toaster } from './components/ui/toaster';
import { EngagementTracker } from './components/engagementTracker';

function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <ImpersonationProvider>
          <ApiProvider>
            <UserProvider>
              {/* For lazy pages outside SidebarLayout (see router.tsx). */}
              <Suspense
                fallback={
                  <div className="flex h-screen w-screen items-center justify-center">
                    <Loader className="animate-spin" />
                  </div>
                }
              >
                <RouterProvider router={router} />
              </Suspense>
              <Toaster />
              <EngagementTracker />
            </UserProvider>
          </ApiProvider>
        </ImpersonationProvider>
      </AuthProvider>
    </QueryProvider>
  );
}

export default App;
